// Guided Mode or Advanced Mode (the mode called "live" in code), chosen in Session settings on the setup screen
// (moved there 2026-10-30: the format screen it was on can no longer be reached).
export const INTERVIEW_MODE_STRINGS = {
  en: {
    title: "How do you want to practise?",
    guidedTitle: "Guided Mode",
    guidedDesc: "You see each question and set the pace: record when you\u2019re ready and submit when you\u2019re done.",
    liveTitle: "Advanced Mode",
    liveDesc: "Like a real interview: audio only, no text. You have 30 seconds to start answering, and the interviewer moves on when you stop speaking.",
    paidOnly: "Available with 30-day full access",
  },
  "pt-BR": {
    title: "Como você quer praticar?",
    guidedTitle: "Modo Guiado",
    guidedDesc: "Você vê cada pergunta e controla o ritmo: grave quando estiver pronto e envie quando terminar.",
    liveTitle: "Modo Avançado",
    liveDesc: "Como uma entrevista real: só áudio, sem texto. Você tem 30 segundos para começar a responder, e o entrevistador continua quando você para de falar.",
    paidOnly: "Disponível com o acesso completo de 30 dias",
  },
  "es-419": {
    title: "¿Cómo quiere practicar?",
    guidedTitle: "Modo Guiado",
    guidedDesc: "Ve cada pregunta y marca el ritmo: grabe cuando esté listo y envíe cuando termine.",
    liveTitle: "Modo Avanzado",
    liveDesc: "Como una entrevista real: solo audio, sin texto. Tiene 30 segundos para empezar a responder, y el entrevistador continúa cuando deja de hablar.",
    paidOnly: "Disponible con el acceso completo de 30 días",
  },
  "fr-CA": {
    title: "Comment voulez-vous pratiquer?",
    guidedTitle: "Mode guidé",
    guidedDesc: "Vous voyez chaque question et choisissez le rythme : enregistrez quand vous êtes prêt et envoyez quand vous avez terminé.",
    liveTitle: "Mode avancé",
    liveDesc: "Comme une vraie entrevue : audio seulement, sans texte. Vous avez 30 secondes pour commencer à répondre, et l\u2019intervieweur continue quand vous arrêtez de parler.",
    paidOnly: "Offert avec l\u2019accès complet de 30 jours",
  },
};

// The free trial is Guided only; everyone else chooses. Free accounts still SEE the
// Live Interview option, greyed out and inactive (design principle, 2026-10-30:
// paid features are shown but not available on a Free Account, so free users see
// what full access includes).
export function canChooseMode(practiceFormat) {
  return practiceFormat !== "quick";
}

export function modeOptionAvailable(mode, practiceFormat) {
  return mode === "guided" || canChooseMode(practiceFormat);
}
